// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__Wq4qE","date":"style_date__32TeU","league":"style_league__bHTPb"};